import { TablePagination, Box, Checkbox, CircularProgress, Container, CssBaseline, FormControlLabel, Grid, Modal, Paper, Table, TableBody, TableCell, TableHead, TableRow, styled, tableCellClasses, TableContainer } from '@mui/material';
import React from 'react'
import { Component } from 'react'
import Constantes from '../php/Constantes';
import { Redirect } from 'react-router-dom/cjs/react-router-dom';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const handleDownloadPdf = (name, data) => {
    const blobData = atob(data);
    const byteArray = new Uint8Array(blobData.length);
    for (let i = 0; i < blobData.length; i++) {
      byteArray[i] = blobData.charCodeAt(i);
    }
    const fileBlob = new Blob([byteArray], { type: 'application/pdf' });
    const fileUrl = URL.createObjectURL(fileBlob);

    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

let filasTotales = 0;
const opcionesFilasPorPagina = [5, 10, 25, 50, 100];

class Jornaleros extends Component {
    constructor(props){
        super(props);
        this.state = {
            //------------------
            pagina: 0,
            filasPorPagina: 5,
            //------------------
            informesAListar: [],
            loading: false,
            errores: null,
            notificaciones: null,
            notificacionesEnvio: null,
            consulta: false,

            busqueda: {
                tipoConsulta: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                anio: '',
            },

            numeroNombre: [],
            consultaEspecifica: false,
            datoEspecifico: {},
        }

        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejoEnvioConsulta = this.manejoEnvioConsulta.bind(this);
        this.manejarConsultaEspecifica = this.manejarConsultaEspecifica.bind(this);
        this.manejarCambiosDatosEspecifico = this.manejarCambiosDatosEspecifico.bind(this);
        this.manejarAtrasConsulta = this.manejarAtrasConsulta.bind(this);
        this.manejarAtrasEspecifica = this.manejarAtrasEspecifica.bind(this);
        this.manejarEnviarJornales = this.manejarEnviarJornales.bind(this);
    }

    async componentDidMount(){
        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });
    }

    handleChangePage = (event, nuevaPagina) => {
        this.setState({ pagina: nuevaPagina });
    };
    
    handleChangeRowsPerPage = (event) => {
        const filasPorPagina = event.target.value === 'all' ? this.state.informesAListar.length : parseInt(event.target.value, 10);
        this.setState({ filasPorPagina, pagina: 0 });
    };
    render(){
        const { pagina, filasPorPagina } = this.state;
        filasTotales = this.state.informesAListar.length;
        return (
            <>
                {!sessionStorage.login
                ?
                    <Redirect to='/login'/>
                :
                    null
                }
                <h3>Jornaleros</h3>
                {this.state.notificacionesEnvio ? (<div className="alert alert-success" > {this.state.notificacionesEnvio}</div>) : null}
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                {this.state.consulta
                ?
                    !this.state.consultaEspecifica
                    ?
                        <Container >
                            <TableContainer style={{width: '80%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{maxWidth: '100%'}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell style={{textAlign: 'center'}}>Número</StyledTableCell>
                                            <StyledTableCell style={{textAlign: 'center'}}>Nombre</StyledTableCell>
                                            <StyledTableCell style={{textAlign: 'center'}}>Año</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.informesAListar.slice(this.state.pagina * this.state.filasPorPagina, this.state.pagina * this.state.filasPorPagina + this.state.filasPorPagina).map((name) => (
                                            <StyledTableRow key={name.idJornalesTrabajados}>
                                                <StyledTableCell style={{textAlign: 'center'}}>{name.numeroFuncionario}</StyledTableCell>
                                                <StyledTableCell style={{textAlign: 'center'}}>{name.nombreFuncionario}</StyledTableCell>
                                                <StyledTableCell style={{textAlign: 'center'}}>{name.anio}</StyledTableCell>
                                                <StyledTableCell style={{textAlign: 'center'}}><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarConsultaEspecifica(name)}>Consultar</button></StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <TablePagination rowsPerPageOptions={opcionesFilasPorPagina} component="div" count={filasTotales} rowsPerPage={this.state.filasPorPagina} page={this.state.pagina} onPageChange={this.handleChangePage} onRowsPerPageChange={this.handleChangeRowsPerPage} labelRowsPerPage="Filas por página" SelectProps={{inputProps: {'aria-label': 'Filas por página',}, displayEmpty: true,}}/>
                            </TableContainer>
                            <button style={{marginTop: '1rem'}} className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarAtrasConsulta}>Volver</button>
                        </Container>
                    :
                        null
                :
                    <Container>
                        <TableContainer style={{width: '80%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                            {this.state.busqueda.tipoConsulta === '1' ? <p style={{color: 'red'}}>Los jornales a consultar son los confirmados en el control de asistencia</p> : null}
                            <Table id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell style={{textAlign: 'center'}}>Consulta</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>Número</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>Nombre</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>Año</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <StyledTableRow>
                                        <StyledTableCell  style={{textAlign: 'center'}}>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8", textAlign: 'center'}} id='tipoConsulta'  value={this.state.busqueda.tipoConsulta} onChange={this.manejarCambiosDatos}>
                                                <option value=''></option>
                                                <option value={1}>JORNALES TRABAJADOS</option>
                                                {/*<option value={2}>JORNALES NO CONVOCADOS</option>*/}
                                            </select>
                                        </StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroFuncionario' value={this.state.busqueda.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>{this.state.busqueda.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='anio' value={this.state.busqueda.anio} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejoEnvioConsulta()}>Consultar</button></StyledTableCell>
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Container>
                }

                {this.state.consultaEspecifica
                ?
                    <Container>
                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                            <h4>{this.state.datoEspecifico.numeroFuncionario} {this.state.datoEspecifico.nombreFuncionario}</h4>
                            <h4>AÑO: {this.state.datoEspecifico.anio}</h4>
                            <Table sx={{maxWidth: '100%'}} id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell style={{textAlign: 'center'}}>Enero</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>Febrero</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>Marzo</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>Abril</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>Mayo</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>Junio</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>Julio</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>Agosto</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>Setiembre</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>Octubre</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>Noviembre</StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}>Diciembre</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <StyledTableRow>
                                        <StyledTableCell style={{textAlign: 'center'}}><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='enero' value={this.state.datoEspecifico.enero} onChange={this.manejarCambiosDatosEspecifico}/></StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='febrero' value={this.state.datoEspecifico.febrero} onChange={this.manejarCambiosDatosEspecifico}/></StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='marzo' value={this.state.datoEspecifico.marzo} onChange={this.manejarCambiosDatosEspecifico}/></StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='abril' value={this.state.datoEspecifico.abril} onChange={this.manejarCambiosDatosEspecifico}/></StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='mayo' value={this.state.datoEspecifico.mayo} onChange={this.manejarCambiosDatosEspecifico}/></StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='junio' value={this.state.datoEspecifico.junio} onChange={this.manejarCambiosDatosEspecifico}/></StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='julio' value={this.state.datoEspecifico.julio} onChange={this.manejarCambiosDatosEspecifico}/></StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='agosto' value={this.state.datoEspecifico.agosto} onChange={this.manejarCambiosDatosEspecifico}/></StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='setiembre' value={this.state.datoEspecifico.setiembre} onChange={this.manejarCambiosDatosEspecifico}/></StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='octubre' value={this.state.datoEspecifico.octubre} onChange={this.manejarCambiosDatosEspecifico}/></StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='noviembre' value={this.state.datoEspecifico.noviembre} onChange={this.manejarCambiosDatosEspecifico}/></StyledTableCell>
                                        <StyledTableCell style={{textAlign: 'center'}}><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='diciembre' value={this.state.datoEspecifico.diciembre} onChange={this.manejarCambiosDatosEspecifico}/></StyledTableCell>
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <button style={{marginTop: '1rem'}} className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarAtrasEspecifica}>Volver</button>
                        <button style={{marginTop: '1rem'}} className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarEnviarJornales}>Enviar</button>
                    </Container>
                :
                    null
                }
            </>
        )
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
            notificacionesEnvio: null,
        });
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado[clave] = valor;
            
            if(clave === 'numeroFuncionario'){
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    numFunActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    numFunActualizado['nombreFuncionario'] = '';
                }
                });
            }
            
            return{
                busqueda: numFunActualizado,
            };
        });
    }

    async manejoEnvioConsulta(e){
        this.setState({
            errores: null,
            notificaciones: null,
            loading: true,
        });

        const cargaUtil = JSON.stringify([this.state.busqueda]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_jornalesTrabajados.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            errores: exito[0],
            loading: false,
        })
        if(exito[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: null,
                consulta: true,
                informesAListar: exito[1],
            })
        }
    }

    manejarConsultaEspecifica(dato){
        this.setState({
            errores: null,
            notificaciones: null,
            consultaEspecifica: true,
            datoEspecifico: dato,
            notificacionesEnvio: null,
        })
    }

    manejarCambiosDatosEspecifico(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
            notificacionesEnvio: null,
        });
        this.setState(state => {
            const numFunActualizado = state.datoEspecifico;
            numFunActualizado[clave] = valor;
            return{
                datoEspecifico: numFunActualizado,
            };
        });
    }

    manejarAtrasConsulta(e){
        e.preventDefault();
        this.setState({
            informesAListar: [],
            consulta: false,
            errores: false,
            notificaciones: false,
            notificacionesEnvio: null,
        })
    }

    manejarAtrasEspecifica(e){
        e.preventDefault();
        this.setState({
            consultaEspecifica: false,
            datoEspecifico: {},
            errores: null,
            notificaciones: null,
            notificacionesEnvio: null,
        })
    }

    async manejarEnviarJornales(e){
        e.preventDefault();

        const cargaUtil = JSON.stringify([this.state.datoEspecifico]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/guardar_jornalesTrabajados.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            errores: exito[0],
            notificacionesEnvio: null,
            loading: false,
        })
        if(exito[0] === 'ok'){
            this.setState({
                errores: null,
                notificacionesEnvio: 'Datos ingresados correctamente',
                consultaEspecifica: false,
                datoEspecifico: {},
            })

            this.manejoEnvioConsulta();
        }
    }
}

export default Jornaleros